import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Modal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
    biomedicalinchargeNameSearchDropdown,
    biomedicalSecoundengineerNameSearchDropdown,
    CalibrationEquipmentDropdown,
    calibrationMethodSearchDropdown,
    ChargesDropdown,
    fetchmaintenanceSaveData,
    MaintenanceDocumentTypeDropdown,
    MaintenanceListing,
    serviceAgentNameSearchDropdown
} from "../../../services/iteminfoservices/Iteminfolistservices";

import dayjs from "dayjs";
import { Controller, useForm } from "react-hook-form";

import DeleteOutline from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import InputField from "../../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../../common/components/FormFields/searchDropdown";
import { ModalStyle } from "../../../../common/components/ModalStyle";
import { ViewMaintenanceData } from "../../../services/maintenanceServices/MaintenanceServices";

export default function MaintenanceEditDialog({ open, onClose, maintenanceId, itemDetails, setSnack, itemInfoId, }) {
    const [maintenanceNumber, setMaintenanceNumber] = useState("");
    const [serviceAgent, setServiceAgent] = useState(null);
    const [serviceAgentOptions, setServiceAgentOptions] = useState([]);
    const [calibrationMethod, setCalibrationMethod] = useState(null);
    const [calibrationOptions, setCalibrationOptions] = useState([]);
    const [serviceAgentSearch, setServiceAgentSearch] = useState("");
    const [searchBarString, setSearchBarString] = useState("");
    const [calibrationMethodOptions, setCalibrationMethodOptions] = useState([]);
    const [calibrationSearch, setCalibrationSearch] = useState("");
    const [activeInterval, setActiveInterval] = useState("D");
    const [assignEngineerOptions, setAssignEngineerOptions] = useState([]);
    const [closedByOptions, setClosedByOptions] = useState([]);
    const [assignEngineerSearch, setAssignEngineerSearch] = useState("");
    const [closedBySearch, setClosedBySearch] = useState("");
    const [inchargeOptions, setInchargeOptions] = useState([]);
    const [inchargeSearch, setInchargeSearch] = useState("");
    const [calType, setCalType] = useState("After");
    const [calibrationRows, setCalibrationRows] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [chargeRows, setChargeRows] = useState([]);
    const [chargeOptions, setChargeOptions] = useState([]);
    const [chargeSearch, setChargeSearch] = useState("");
    const [calibrationEquipOptions, setCalibrationEquipOptions] = useState([]);
    const [calibrationEquipSearch, setCalibrationEquipSearch] = useState("");
    const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
    const [documentTypeSearch, setDocumentTypeSearch] = useState("");
    const [documents, setDocuments] = useState([]);
    const [maintenanceRows, setMaintenanceRows] = useState([]);
    const [maintenanceLoading, setMaintenanceLoading] = useState(false);
    const [latestRowKey, setLatestRowKey] = useState(null);
    const [editId, setEditId] = useState(null);
    const [files, setFiles] = useState([]);
    const [editMaintenanceData, setEditMaintenanceData] = useState(null);
    const [editData, setEditData] = useState(null);
    const fileInputRef = React.useRef(null);

    const maintenanceTableData = maintenanceRows.map((row) => ({
        "Maintenance No": row.maintenanceNumber,
        "Maintenance Date": row.maintenanceDate,
        "Next Maintenance Date": row.nextMaintenanceDate,
        "Service Agent": row.serviceAgentName,
    }));


    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64 = reader.result.split(",")[1];
                resolve(base64);
            };
            reader.onerror = (error) => reject(error);
        });


    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        let hasDuplicate = false;

        setFiles(prev => {
            const existingKeys = new Set([
                ...prev.map(f => `${f.name}_${f.size}`),
                ...documents.map(d => d.fileName),
            ]);

            const uniqueNewFiles = selectedFiles.filter(file => {
                const key = `${file.name}_${file.size}`;
                if (existingKeys.has(key) || existingKeys.has(file.name)) {
                    hasDuplicate = true;
                    return false;
                }
                return true;
            });

            return [...prev, ...uniqueNewFiles];
        });

        if (hasDuplicate) {
            setSnack({
                open: true,
                message: "Some files were already selected",
                severity: "warning",
            });
        }

        e.target.value = null;
    };
    const handleAddDocument = async () => {
        const documentTypeObj = watch("documentType");
        if (!documentTypeObj || files.length === 0) return;

        const existingFileNames = new Set(
            documents.map(d => d.fileName)
        );

        const newDocs = await Promise.all(
            files
                .filter(file => !existingFileNames.has(file.name)) // 🔥 BLOCK DUPLICATES
                .map(async (file) => {
                    const base64 = await toBase64(file);
                    return {
                        documentType:
                            documentTypeObj.documentTypeName ||
                            documentTypeObj.label ||
                            documentTypeObj.value,
                        documentTypeId: documentTypeObj.id,
                        base64File: base64,
                        fileName: file.name,
                        contentType: file.type,
                    };
                })
        );

        if (newDocs.length < files.length) {
            setSnack({
                open: true,
                message: "Some files were already added",
                severity: "warning",
            });
        }

        setDocuments(prev => [...prev, ...newDocs]);
        setFiles([]);

        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const [maintenanceItemDetails, setMaintenanceItemDetails] = useState({
        ItemName: "",
        SerialNo: "",
        ModelNo: "",
        LastMDate: "",
        NextMDate: "",
        InsEDate: "",
    });

    const defaultFormValues = {
        maintenanceNo: "",
        serviceAgent: null,
        contactPerson: "",
        maintenanceDate: new Date(),
        nextMaintenanceDate: new Date(),
        calibrationInterval: null,
        calibrationDate: new Date(),
        calibrationMethod: null,
        calibrationEquipment: [],
        adjustment: "",
        certificateNo: "",
        performedBy: "",
        stdTemp: "",
        stdVolt: "",
        stdFlow: "",
        tolTemp: "",
        tolVolt: "",
        tolFlow: "",
        caTemp: "",
        caVolt: "",
        caFlow: "",
        assignEngineer: null,
        closedBy: null,
        assignIncharge: null,
        documentType: null,
        isFree: false,
        underWarranty: false,
        calibrationPass: false,
    };


    const { control, watch, setValue, reset } = useForm({
        defaultValues: defaultFormValues,
    });


    const resetAllData = () => {
        // react-hook-form reset
        reset({
            maintenanceNo: "",
            serviceAgent: null,
            contactPerson: "",
            maintenanceDate: new Date(),
            nextMaintenanceDate: new Date(),
            calibrationInterval: "",
            calibrationDate: new Date(),
            calibrationMethod: "",
            calibrationEquipment: [],
            adjustment: "",
            certificateNo: "",
            performedBy: "",
            stdTemp: "",
            stdVolt: "",
            stdFlow: "",
            tolTemp: "",
            tolVolt: "",
            tolFlow: "",
            caTemp: "",
            caVolt: "",
            caFlow: "",
            assignEngineer: "",
            closedBy: "",
            assignIncharge: "",
            documentType: null,
        });

        setValue("chargeName", null);
        setChargeSearch("");
        setChargeOptions([]);
        setValue("rate", "");
        setValue("quantity", "");
        setValue("tax", "");
        setValue("total", "");

        setCalibrationRows([]);
        setChargeRows([]);
        setDocuments([]);
        setFiles([]);
        setServiceAgentOptions([]);
        setCalibrationMethodOptions([]);
        setCalibrationEquipOptions([]);
        setChargeOptions([]);
        setDocumentTypeOptions([]);
        setSearchBarString("");
        setCalibrationSearch("");
        setCalibrationEquipSearch("");
        setChargeSearch("");
        setDocumentTypeSearch("");

        setCalType("After");
    };

    const isDocumentValid =
        watch("documentType") && (files.length > 0 || documents.length > 0);

    const complaintStatus = watch("complaintStatus");

    const numberOptions = Array.from({ length: 30 }, (_, i) => ({
        label: String(i + 1),
        value: i + 1,
    }));

    const intervalMap = {
        D: "day",
        W: "week",
        M: "month",
        Y: "year",
    };
    const rate = watch("rate");
    const quantity = watch("quantity");
    const tax = watch("tax");

    const handleSave = async () => {
        const values = watch();

        const documentsPayload = documents?.map((doc) => ({
            documentType: doc.documentType,
            base64File: doc.base64File || "",
            fileName: doc.fileName || "",
            contentType: doc.contentType || "",
        })) || [];

        const payload = {
            // id: null,
            id: editId ?? null,
            itemInfoId: Number.isFinite(Number(itemInfoId))
                ? Number(itemInfoId)
                : null,
            maintenanceNumber: Number(values.maintenanceNo) || null,
            maintenanceDate: dayjs(values.maintenanceDate).format("YYYY-MM-DD"),
            nextMaintenanceDate: dayjs(values.nextMaintenanceDate).format("YYYY-MM-DD"),
            serviceAgentId: values.serviceAgent?.id || null,
            serviceAgentMobNo: values.serviceAgent?.mobileNo || "",
            contactPerson: values.contactPerson || "",
            contactPersonMobileNo: values.contactPersonMobileNo || "",
            calibrationTypeId: values.calibrationMethod?.id || null,
            calibrationDate: dayjs(values.calibrationDate).format("YYYY-MM-DD"),
            calibrationInterval:
                values.calibrationInterval?.value && intervalMap[activeInterval]
                    ? `${values.calibrationInterval.value} ${intervalMap[activeInterval]}`
                    : values.calibrationInterval
                        ? `${values.calibrationInterval} ${intervalMap[activeInterval]}`
                        : null,
            // calibrationPass: true,
            calibrationPass: values.calibrationPass === true,
            isCalibration: true,
            adjustment: values.adjustment || "",
            certificateNo: values.certificateNo || "",
            performedBy: values.performedBy || "",
            biomedicalEngEmpId: values.assignEngineer?.id || null,
            secondBiomedicalEngEmpId: values.closedBy?.id || null,
            biomedicalInchargeEmpId: values.assignIncharge?.id || null,
            checkedBy: values.assignEngineer?.id || null,
            departmentId: itemDetails?.["Department Id"] || null,
            supplierId: values.serviceAgent?.supplierId || null,
            amountIncurred: Number(values.total) || null,
            inHouseService: null,
            // isFree: true,
            // underWarranty: true,
            isFree: values.isFree === true,
            underWarranty: values.underWarranty === true,
            complaintId: values.complaintId || null,
            futureActionToBeTaken: values.futureAction || null,
            commentsOnUseOfEquipment: values.comments || null,
            stdTemperature: Number(values.stdTemp) || null,
            stdVoltage: Number(values.stdVolt) || null,
            stdFlowRate: Number(values.stdFlow) || null,
            temperatureTolerance: Number(values.tolTemp) || null,
            voltageTolerance: Number(values.tolVolt) || null,
            flowRateTolerance: Number(values.tolFlow) || null,
            calibrationEquipmentIds:
                Array.isArray(values.calibrationEquipment)
                    ? values.calibrationEquipment.map(eq => eq.id)
                    : [],
            calibrationDetails: calibrationRows.map((row) => ({
                afterCalibration: row.when === "After",
                temperature: Number(row.temperature) || null,
                voltage: Number(row.voltage) || null,
                flowRate: Number(row.flowRate) || null,
            })),

            charges: chargeRows.map((row) => ({
                chargeId: row.chargeId || null,
                chargeName: row.chargeName?.label || "",
                rate: Number(row.rate) || null,
                quantity: Number(row.quantity) || null,
                taxPercent: Number(row.tax) || null,
                totalCharges: Number(row.total) || null,
            })),

            documents: documentsPayload,
        };
        fetchmaintenanceSaveData(payload)
            .then((res) => {
                if (res?.data?.statusCode === 200) {

                    setSnack({
                        open: true,
                        message:
                            res.data.message ||
                            (editId ? "Maintenance updated successfully" : "Maintenance saved successfully"),
                        severity: "success",
                    });

                    MaintenanceListing(maintenanceId)
                        .then((r) => {
                            setMaintenanceRows(
                                Array.isArray(r?.data?.result) ? r.data.result : []
                            );
                        });

                    setLatestRowKey(payload.maintenanceNumber);

                    setConfirmOpen(false);

                    setTimeout(() => {
                        onClose();
                        resetAllData();
                    }, 300);
                }
            })
            .catch(() => {
                setSnack({
                    open: true,
                    message: "Failed to save maintenance",
                    severity: "error",
                });
            });

    };

    const handleDocumentTypeSearch = (inputValue) => {
        if (typeof inputValue !== "string") return;

        setDocumentTypeSearch(inputValue);
        const trimmed = inputValue.trim();

        if (!trimmed) {
            setDocumentTypeOptions([]);
            return;
        }

        MaintenanceDocumentTypeDropdown(trimmed)
            .then((res) => {
                setDocumentTypeOptions(res?.data?.result ?? []);
            })
            .catch(() => setDocumentTypeOptions([]));
    };

    const handleCalibrationEquipSearch = (inputValue) => {
        if (typeof inputValue !== "string") return;

        setCalibrationEquipSearch(inputValue);
        const trimmed = inputValue.trim();

        if (!trimmed) {
            setCalibrationEquipOptions([]);
            return;
        }

        CalibrationEquipmentDropdown(trimmed)
            .then((res) => {
                setCalibrationEquipOptions(res?.data?.result ?? []);
            })
            .catch(() => setCalibrationEquipOptions([]));
    };

    const handleChargeSearch = (inputValue) => {
        if (typeof inputValue !== "string") return;

        setChargeSearch(inputValue);
        const trimmed = inputValue.trim();

        if (!trimmed) {
            setChargeOptions([]);
            return;
        }

        ChargesDropdown(trimmed)
            .then((res) => {
                setChargeOptions(res?.data?.result ?? []);
            })
            .catch(() => setChargeOptions([]));
    };


    const handleAddCharge = () => {
        const values = watch();

        if (!values.chargeName || !values.rate || !values.quantity) return;

        setChargeRows((prev) => [
            ...prev,
            {
                chargeId: values.chargeName.id,
                chargeName: values.chargeName.label,
                chargeName: values.chargeName,
                rate: Number(values.rate),
                quantity: Number(values.quantity),
                tax: Number(values.tax) || 0,
                total: Number(values.total) || 0,
            },
        ]);

        setValue("chargeName", "");
        setValue("rate", "");
        setValue("quantity", "");
        setValue("tax", "");
        setValue("total", "");
    };

    useEffect(() => {
        const r = Number(rate) || 0;
        const q = Number(quantity) || 0;
        const t = Number(tax) || 0;

        const subTotal = r * q;
        const total = subTotal + (subTotal * t) / 100;

        setValue("total", total || "");
    }, [rate, quantity, tax, setValue]);

    const bodyCellSx = {
        padding: "0 12px",
        height: 32,
        fontSize: "13px",
        verticalAlign: "middle",
    };

    const headerCellSx = {
        padding: "6px 12px",
        fontWeight: 600,
        backgroundColor: "#f3f3f3",
    };

    const handleAddCalibration = () => {
        const temp = control._formValues.caTemp;
        const volt = control._formValues.caVolt;
        const flow = control._formValues.caFlow;

        if (!temp || !volt || !flow) return;

        setCalibrationRows((prev) => [
            ...prev,
            {
                when: calType,
                temperature: temp,
                voltage: volt,
                flowRate: flow,
            },
        ]);

        setValue("caTemp", "");
        setValue("caVolt", "");
        setValue("caFlow", "");
    };

    const handleServiceAgentChange = (inputValue) => {
        if (typeof inputValue !== "string") return;

        setSearchBarString(inputValue);

        const trimmed = inputValue.trim();
        if (!trimmed) {
            setServiceAgentOptions([]);
            return;
        }

        serviceAgentNameSearchDropdown(trimmed)
            .then((res) => {
                setServiceAgentOptions(res?.data?.result ?? []);
            })
            .catch(() => {
                setServiceAgentOptions([]);
            });
    };

    const handleCalibrationMethodChange = (inputValue) => {
        if (typeof inputValue !== "string") return;

        setCalibrationSearch(inputValue);

        const trimmed = inputValue.trim();
        if (!trimmed) {
            setCalibrationMethodOptions([]);
            return;
        }

        calibrationMethodSearchDropdown(trimmed)
            .then((res) => {
                setCalibrationMethodOptions(res?.data?.result ?? []);
            })
            .catch(() => {
                setCalibrationMethodOptions([]);
            });
    };

    const handleAssignEngineerSearch = (inputValue) => {
        if (typeof inputValue !== "string") return;

        setAssignEngineerSearch(inputValue);
        const trimmed = inputValue.trim();

        if (!trimmed) {
            setAssignEngineerOptions([]);
            return;
        }

        biomedicalSecoundengineerNameSearchDropdown(trimmed)
            .then((res) => {
                setAssignEngineerOptions(res?.data?.result ?? []);
            })
            .catch(() => setAssignEngineerOptions([]));
    };

    const handleClosedBySearch = (inputValue) => {
        if (typeof inputValue !== "string") return;

        setClosedBySearch(inputValue);
        const trimmed = inputValue.trim();

        if (!trimmed) {
            setClosedByOptions([]);
            return;
        }

        biomedicalSecoundengineerNameSearchDropdown(trimmed)
            .then((res) => {
                setClosedByOptions(res?.data?.result ?? []);
            })
            .catch(() => setClosedByOptions([]));
    };

    const handleInchargeSearch = (inputValue) => {
        if (typeof inputValue !== "string") return;

        setInchargeSearch(inputValue);
        const trimmed = inputValue.trim();

        if (!trimmed) {
            setInchargeOptions([]);
            return;
        }

        biomedicalinchargeNameSearchDropdown(trimmed)
            .then((res) => {
                setInchargeOptions(res?.data?.result ?? []);
            })
            .catch(() => {
                setInchargeOptions([]);
            });
    };


    useEffect(() => {
        if (!itemDetails) return;

        const normalize = (v) => (v && v !== "NA" ? v : "-");

        setMaintenanceItemDetails({
            ItemName: normalize(itemDetails?.["Item Name"]),
            SerialNo: normalize(itemDetails?.["Serial No"]),
            ModelNo: normalize(itemDetails?.["Model No"]),
            LastMDate: itemDetails?.["Last Main. Date"] || null,
            NextMDate: itemDetails?.["Next Main. Date"] || null,
            InsEDate: itemDetails?.["Insurance End Date"] || null,
        });
    }, [itemDetails]);


    useEffect(() => {
        if (!open) {

            reset(defaultFormValues);

            setValue("calibrationMethod", null);
            setValue("calibrationEquipment", null);
            setValue("adjustment", "");
            setValue("certificateNo", "");
            setValue("performedBy", "");
            setCalibrationMethodOptions([]);
            setCalibrationEquipOptions([]);
            setCalibrationSearch("");
            setCalibrationEquipSearch("");
            setCalibrationRows([]);
            setChargeRows([]);
            setDocuments([]);
            setFiles([]);
        }
    }, [open, setValue]);

    useEffect(() => {
        if (!open || !maintenanceId) return;
        const fetchData = async () => {
            const res = await ViewMaintenanceData(maintenanceId);
            const data = res?.data?.result;
            if (!data) return;

            setDocuments([]);
            setFiles([]);
            setEditId(data.id);

            const selectedEquipments = Array.isArray(data.calibrationEquipmentsUsed)
                ? data.calibrationEquipmentsUsed.map(eq => ({
                    id: eq.id,
                    label: eq.description,
                    value: eq.equipmentCode,
                }))
                : [];
            setCalibrationEquipOptions(selectedEquipments);

            setMaintenanceLoading(true);
            MaintenanceListing(itemInfoId)
                .then((r) => {
                    setMaintenanceRows(
                        Array.isArray(r?.data?.result) ? r.data.result : []
                    );
                })
                .finally(() => setMaintenanceLoading(false));

            reset({
                maintenanceNo: data.maintenanceNumber ?? "",
                maintenanceDate: data.maintenanceDate
                    ? dayjs(data.maintenanceDate).toDate()
                    : new Date(),

                nextMaintenanceDate: data.nextMaintenanceDate
                    ? dayjs(data.nextMaintenanceDate).toDate()
                    : new Date(),

                contactPerson: data.contactPerson || "",
                contactPersonMobileNo: data.contactPersonMobileNo || "",

                serviceAgent: data.serviceAgentName
                    ? {
                        id: data.serviceAgentId ?? null,
                        label: data.serviceAgentName,
                        value: data.serviceAgentName,
                        mobileNo: data.serviceAgentMobNo || "",
                        supplierId: data.supplierId ?? null,
                    }
                    : null,
                calibrationPass: !!data.calibrationPass,
                calibrationDate: data.calibrationDate
                    ? dayjs(data.calibrationDate).toDate()
                    : new Date(),

                calibrationMethod: data.calibrationMethodName
                    ? {
                        id: data.calibrationTypeId ?? null,
                        label: data.calibrationMethodName,
                        value: data.calibrationMethodName,
                    }
                    : null,

                isFree: !!data.isFree,
                underWarranty: !!data.underWarranty,

                adjustment: data.adjustment || "",
                certificateNo: data.certificateNo || "",
                performedBy: data.performedBy || "",

                stdTemp: data.stdTemperature ?? "",
                stdVolt: data.stdVoltage ?? "",
                stdFlow: data.stdFlowRate ?? "",

                tolTemp: data.temperatureTolerance ?? "",
                tolVolt: data.voltageTolerance ?? "",
                tolFlow: data.flowRateTolerance ?? "",

                assignEngineer: data.biomedicalEngineerName
                    ? {
                        id: data.biomedicalEngineerId ?? null,
                        label: data.biomedicalEngineerName,
                        value: data.biomedicalEngineerName,
                    }
                    : null,

                closedBy: data.secondBiomedicalEngineerName
                    ? {
                        id: data.secondBiomedicalEngineerId ?? null,
                        label: data.secondBiomedicalEngineerName,
                        value: data.secondBiomedicalEngineerName,
                    }
                    : null,

                assignIncharge: data.biomedicalInchargeName
                    ? {
                        id: data.biomedicalInchargeId ?? null,
                        label: data.biomedicalInchargeName,
                        value: data.biomedicalInchargeName,
                    }
                    : null,

                calibrationEquipment: selectedEquipments,

            });

            if (data.documents?.length > 0) {
                const docType = data.documents[0].documentType;

                const selectedDocType = {
                    id: data.documents[0].documentTypeId ?? null,
                    label: docType,
                    value: docType,
                };

                setValue("documentType", selectedDocType);
                setDocumentTypeSearch(docType);
                setDocumentTypeOptions([selectedDocType]);
            }


            if (data.calibrationInterval) {
                const [num, unit] = data.calibrationInterval.split(" ");

                const unitMap = {
                    day: "D",
                    week: "W",
                    month: "M",
                    year: "Y",
                };

                setValue("calibrationInterval", {
                    label: num,
                    value: Number(num),
                });
                setActiveInterval(unitMap[unit]);
            }

            setValue("calibrationPass", !!data.calibrationPass);
            setCalibrationRows(
                (data.calibrationDetails || []).map(row => ({
                    when: row.afterCalibration ? "After" : "Before", // ✅ FIX
                    temperature: row.temperature,
                    voltage: row.voltage,
                    flowRate: row.flowRate,
                }))
            );
            setChargeRows(
                (data.charges || []).map(c => ({
                    chargeId: c.chargeId,
                    chargeName: {
                        id: c.chargeId,
                        chargeName: c.chargeName,
                        value: c.chargeName,
                        label: c.chargeName,
                    },

                    rate: Number(c.rate),
                    quantity: Number(c.quantity),
                    tax: Number(c.taxPercent),
                    total: Number(c.totalCharges),
                }))
            );

            setDocuments(
                (data.documents || []).filter(
                    (doc, index, self) =>
                        index === self.findIndex(d => d.fileName === doc.fileName)
                )
            );
        };

        fetchData();
    }, [maintenanceId, open, reset, setValue]);


    return (
        <Modal open={open}>
            <Box sx={ModalStyle} className="w-[85%] h-[85%] space-y-2" >
                <div className="flex justify-between">
                    <label className="font-semibold">
                        <span>Maintenance Details</span>
                    </label>

                    <CloseModalIcon onClick={onClose} />
                </div>
                <div>

                    {/* ================= Detalis ================= */}
                    <div className="bg-[#f7f7f7] rounded-md border border-[#cfcfcf] px-4 py-3 my-1">
                        <div className="grid grid-cols-3 gap-y-3 gap-x-10">

                            <div className="grid grid-cols-[170px_20px_1fr] text-[13px] font-semibold">
                                <span>Equipment Name</span>
                                <span className="text-center">:</span>
                                <span>{maintenanceItemDetails?.ItemName || "-"}</span>
                            </div>

                            <div className="grid grid-cols-[170px_20px_1fr] text-[13px] font-semibold">
                                <span>Serial No.</span>
                                <span className="text-center">:</span>
                                <span>{maintenanceItemDetails?.SerialNo || "-"}</span>
                            </div>

                            <div className="grid grid-cols-[170px_20px_1fr] text-[13px] font-semibold">
                                <span>Model No.</span>
                                <span className="text-center">:</span>
                                <span>{maintenanceItemDetails?.ModelNo || "-"}</span>
                            </div>

                            <div className="grid grid-cols-[170px_20px_1fr] text-[13px] font-semibold">
                                <span>Last Maint. Date</span>
                                <span className="text-center">:</span>
                                <span>
                                    {maintenanceItemDetails?.LastMDate
                                        ? dayjs(maintenanceItemDetails.LastMDate).format("YYYY-MM-DD")
                                        : "-"}
                                </span>
                            </div>

                            <div className="grid grid-cols-[170px_20px_1fr] text-[13px] font-semibold">
                                <span>Next Maint. Date</span>
                                <span className="text-center">:</span>
                                <span>
                                    {maintenanceItemDetails?.NextMDate
                                        ? dayjs(maintenanceItemDetails.NextMDate).format("YYYY-MM-DD")
                                        : "-"}
                                </span>
                            </div>

                            <div className="grid grid-cols-[170px_20px_1fr] text-[13px] font-semibold">
                                <span>Insurance End Date</span>
                                <span className="text-center">:</span>
                                <span>
                                    {maintenanceItemDetails?.InsEDate
                                        ? dayjs(maintenanceItemDetails.InsEDate).format("YYYY-MM-DD")
                                        : "-"}
                                </span>
                            </div>

                        </div>
                    </div>

                    {/* =================  Equipment Maintenance History &  New Maintenance Details ================= */}
                    <div className="grid grid-cols-2 gap-3">

                        <div className="border rounded-md bg-white">
                            <div className="bg-lime-200 text-sm font-semibold px-3 py-2 rounded-t-md">
                                Equipment Maintenance History
                            </div>

                            {maintenanceLoading ? (
                                <div className="flex items-center justify-center py-6 text-gray-400 text-sm">
                                    Loading...
                                </div>
                            ) : maintenanceTableData.length > 0 ? (
                                <div className="overflow-x-auto">
                                    <CommonDynamicTableNew
                                        dataResult={maintenanceTableData}
                                        actionsRequired={false}
                                        highlightRow={true}
                                        removeHeaders={["Sr No."]}
                                        activeRowKey={latestRowKey}
                                        rowKeyField="Maintenance No"
                                    />
                                </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center py-6 text-gray-400 text-sm">
                                    <svg width="40" height="40" fill="none" stroke="currentColor">
                                        <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5l5 5v11a2 2 0 01-2 2z" />
                                    </svg>
                                    <p>No Records Found...</p>
                                </div>
                            )}
                        </div>


                        <div className="border rounded-md bg-white">

                            <div className="bg-yellow-200 text-sm font-semibold px-3 py-2 rounded-t-md">
                                New Maintenance Details
                            </div>


                            <div className="p-3 grid grid-cols-2 gap-3">

                                <InputField
                                    control={control}
                                    name="maintenanceNo"
                                    label="Maintenance No"
                                    placeholder="Maintenance No"
                                    required
                                />

                                <DatePickerField
                                    control={control}
                                    name="maintenanceDate"
                                    label="Maintenance Date"
                                    inputFormat={"dd-MM-yyyy"}
                                />


                                <SearchDropdown
                                    control={control}
                                    name="serviceAgent"
                                    placeholder="Search Service Agent"
                                    dataArray={serviceAgentOptions}
                                    inputValue={searchBarString}
                                    isClearable
                                    searchIcon
                                    handleInputChange={handleServiceAgentChange}
                                    getOptionLabel={(option) => option?.value || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                />

                                <InputField
                                    control={control}
                                    name="contactPerson"
                                    label="Contact Person"
                                />


                                <DatePickerField
                                    control={control}
                                    name="nextMaintenanceDate"
                                    label="Next Maintenance Date"
                                    inputFormat={"dd-MM-yyyy"}
                                />

                            </div>
                        </div>


                    </div>

                    {/* ================= CALIBRATION ================= */}
                    <div className="border rounded-md bg-white mt-2">
                        <div className="bg-purple-100 text-sm font-semibold px-3 py-2 rounded-t-md">
                            Calibration
                        </div>

                        <div className="p-3 space-y-4">

                            <div className="grid grid-cols-4 gap-3">
                                <SearchDropdown
                                    control={control}
                                    name="calibrationInterval"
                                    placeholder="Calibration Interval *"
                                    dataArray={numberOptions}
                                    isSearchable={false}
                                    searchIcon
                                    isClearable
                                    handleInputChange={() => { }}
                                    getOptionLabel={(option) => option.label}
                                    isOptionEqualToValue={(option, value) =>
                                        option.value === value?.value
                                    }
                                />

                                <div className="flex items-center gap-2">
                                    {[
                                        { key: "D", label: "Day" },
                                        { key: "W", label: "Week" },
                                        { key: "M", label: "Month" },
                                        { key: "Y", label: "Year" },
                                    ].map(({ key, label }) => {
                                        const isActive = activeInterval === key;

                                        return (
                                            <div key={key} className="relative group">
                                                <button
                                                    type="button"
                                                    onClick={() => setActiveInterval(key)}
                                                    className={`w-8 h-8 rounded-full text-xs font-semibold
                                                       ${isActive
                                                            ? "bg-[#0F172A] text-white border border-[#0F172A]"
                                                            : "bg-white text-[#0F172A] border border-[#0F172A]"
                                                        }`}
                                                >
                                                    {key}
                                                </button>

                                                <span
                                                    className="
                                                            absolute -bottom-7 left-1/2 -translate-x-1/2
                                                            bg-black text-white text-xs px-2 py-1 rounded
                                                            opacity-0 group-hover:opacity-100
                                                            transition whitespace-nowrap z-50
                                                        "
                                                >
                                                    {label}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>

                            </div>

                            <div className="grid grid-cols-4 gap-3">
                                <DatePickerField
                                    control={control}
                                    name="calibrationDate"
                                    label="Calibration Date"
                                    inputFormat={"dd-MM-yyyy"}
                                />

                                <SearchDropdown
                                    control={control}
                                    name="calibrationMethod"
                                    placeholder="Calibration Method"
                                    dataArray={calibrationMethodOptions}
                                    inputValue={calibrationSearch}
                                    isClearable
                                    handleInputChange={handleCalibrationMethodChange}
                                    getOptionLabel={(option) => option?.value || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                />

                                <SearchDropdown
                                    control={control}
                                    name="calibrationEquipment"
                                    placeholder="Calibration Equipment Used"
                                    dataArray={calibrationEquipOptions}
                                    isMulti
                                    isClearable
                                    handleInputChange={handleCalibrationEquipSearch}
                                    getOptionLabel={(option) => option?.label || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                />

                                <InputField
                                    control={control}
                                    name="adjustment"
                                    label="Adjustment"
                                />
                            </div>


                            <div className="grid grid-cols-4 gap-3 items-center">
                                <InputField
                                    control={control}
                                    name="certificateNo"
                                    label="Certificate Number"
                                />

                                <InputField
                                    control={control}
                                    name="performedBy"
                                    label="Performed By"
                                />

                                <Controller
                                    name="calibrationPass"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <label className="flex items-center gap-2 text-sm font-semibold">
                                            <input
                                                type="checkbox"
                                                checked={!!field.value}
                                                onChange={(e) => field.onChange(e.target.checked)}
                                            />
                                            Calibration Pass
                                        </label>
                                    )}
                                />
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 items-center">
                                <span className="font-semibold text-sm md:col-span-1">
                                    Standard :
                                </span>

                                <InputField
                                    control={control}
                                    name="stdTemp"
                                    label="Temperature"

                                />

                                <InputField
                                    control={control}
                                    name="stdVolt"
                                    label="Voltage"

                                />

                                <InputField
                                    control={control}
                                    name="stdFlow"
                                    label="Flow Rate"

                                />
                            </div>


                            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 items-center">
                                <span className="font-semibold text-sm md:col-span-1">
                                    Tolerance :
                                </span>

                                <div className="flex items-center gap-1">
                                    <span className="text-2xl font-semibold">±</span>
                                    <InputField
                                        control={control}
                                        name="tolTemp"
                                        label="Temperature"

                                    />
                                </div>

                                <div className="flex items-center gap-1">
                                    <span className="text-2xl font-semibold">±</span>
                                    <InputField
                                        control={control}
                                        name="tolVolt"
                                        label="Voltage"

                                    />
                                </div>

                                <div className="flex items-center gap-1">
                                    <span className="text-2xl font-semibold">±</span>
                                    <InputField
                                        control={control}
                                        name="tolFlow"
                                        label="Flow Rate"

                                    />
                                </div>
                            </div>

                            <div className="space-y-2">
                                <span className="font-semibold text-sm">Calibration Details</span>

                                <div className="flex items-center gap-3">
                                    <label className="flex items-center gap-1 text-sm">
                                        <input
                                            type="radio"
                                            name="calType"
                                            value="After"
                                            checked={calType === "After"}
                                            onChange={() => setCalType("After")}
                                        />
                                        After
                                    </label>

                                    <label className="flex items-center gap-1 text-sm">
                                        <input
                                            type="radio"
                                            name="calType"
                                            value="Before"
                                            checked={calType === "Before"}
                                            onChange={() => setCalType("Before")}
                                        />
                                        Before
                                    </label>

                                    <InputField control={control} name="caTemp" label="Temperature" />
                                    <InputField control={control} name="caVolt" label="Voltage" />
                                    <InputField control={control} name="caFlow" label="Flow Rate" />

                                    <button
                                        type="button"
                                        onClick={handleAddCalibration}
                                        className="h-[34px] w-[80px] px-3 rounded border border-blue-900 text-blue-900 text-xs font-semibold hover:bg-blue-50"
                                    >
                                        Add
                                    </button>

                                </div>

                                {calibrationRows.length === 0 ? (
                                    <div className="flex flex-col items-center justify-center py-6 text-gray-400 text-sm">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-10 w-10 mb-2 text-gray-400"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5l5 5v11a2 2 0 01-2 2z"
                                            />
                                        </svg>
                                        <p>No Records Found...</p>
                                    </div>
                                ) : (

                                    <TableContainer component={Paper}
                                        variant="outlined"
                                        sx={{ width: "100%", overflowX: "auto" }}
                                    >
                                        <Table size="small"
                                            stickyHeader
                                            sx={{ minWidth: 600 }}>

                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ ...headerCellSx, textAlign: "center", width: 80 }}>
                                                        Actions
                                                    </TableCell>
                                                    <TableCell sx={headerCellSx}>When</TableCell>
                                                    <TableCell sx={headerCellSx}>Temperature</TableCell>
                                                    <TableCell sx={headerCellSx}>Voltage</TableCell>
                                                    <TableCell sx={headerCellSx}>Flow Rate</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {calibrationRows.map((row, index) => (
                                                    <TableRow key={index} sx={{ height: 32 }}>

                                                        <TableCell sx={{ ...bodyCellSx, textAlign: "center" }}>
                                                            <IconButton
                                                                size="small"
                                                                sx={{ padding: "2px" }}
                                                                color="error"
                                                                onClick={() =>
                                                                    setCalibrationRows((prev) =>
                                                                        prev.filter((_, i) => i !== index)
                                                                    )
                                                                }
                                                            >
                                                                <DeleteOutline fontSize="small" />
                                                            </IconButton>
                                                        </TableCell>

                                                        <TableCell sx={bodyCellSx}>{row.when}</TableCell>
                                                        <TableCell sx={bodyCellSx}>{row.temperature}</TableCell>
                                                        <TableCell sx={bodyCellSx}>{row.voltage}</TableCell>
                                                        <TableCell sx={bodyCellSx}>{row.flowRate}</TableCell>
                                                    </TableRow>
                                                ))}
                                                {calibrationRows.length < 3 && (
                                                    <TableRow sx={{ height: 200 - calibrationRows.length * 32 }}>
                                                        <TableCell colSpan={5} />
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </div>

                            <div className="grid grid-cols-3 gap-3">
                                <SearchDropdown
                                    control={control}
                                    name="assignEngineer"
                                    placeholder="Assign To (Biomedical Engineer)"
                                    dataArray={assignEngineerOptions}
                                    inputValue={assignEngineerSearch}
                                    isClearable
                                    searchIcon
                                    handleInputChange={handleAssignEngineerSearch}
                                />

                                <SearchDropdown
                                    control={control}
                                    name="closedBy"
                                    placeholder="Closed By (Biomedical Engineer)"
                                    dataArray={closedByOptions}
                                    inputValue={closedBySearch}
                                    isClearable
                                    searchIcon
                                    handleInputChange={handleClosedBySearch}
                                />

                                <SearchDropdown
                                    control={control}
                                    name="assignIncharge"
                                    placeholder="Assign To (Biomedical Incharge)"
                                    dataArray={inchargeOptions}
                                    inputValue={inchargeSearch}
                                    isClearable
                                    searchIcon
                                    handleInputChange={handleInchargeSearch}
                                />

                            </div>
                        </div>
                    </div>

                    {/* ================= Charges ================= */}
                    <div className="h-[1px] bg-blue-900 w-full mb-1" />

                    <div className="border rounded-md bg-white mt-2 ">
                        <div className="flex items-center gap-4 px-3 py-2 border-b">
                            <span className="font-semibold text-sm">Charges</span>

                            <Controller
                                name="isFree"
                                control={control}
                                defaultValue={false}
                                render={({ field }) => (
                                    <label className="flex items-center gap-1 text-sm">
                                        <input
                                            type="checkbox"
                                            checked={!!field.value}
                                            onChange={(e) => field.onChange(e.target.checked)}
                                        />
                                        Free
                                    </label>
                                )}
                            />

                            <Controller
                                name="underWarranty"
                                control={control}
                                defaultValue={false}
                                render={({ field }) => (
                                    <label className="flex items-center gap-1 text-sm">
                                        <input
                                            type="checkbox"
                                            checked={!!field.value}
                                            onChange={(e) => field.onChange(e.target.checked)}
                                        />
                                        Under Warranty
                                    </label>
                                )}
                            />

                        </div>

                        <div className="p-3 flex gap-3">

                            <div className="min-w-[450px]">
                                <SearchDropdown
                                    control={control}
                                    name="chargeName"
                                    placeholder="Charges"
                                    dataArray={chargeOptions}
                                    inputValue={chargeSearch}
                                    isClearable
                                    searchIcon
                                    handleInputChange={handleChargeSearch}
                                    getOptionLabel={(option) => option?.chargeName || option?.value || ""}
                                    isOptionEqualToValue={(option, value) =>
                                        option?.id === value?.id
                                    }
                                />
                            </div>

                            <div className="w-[200px]">
                                <InputField control={control} name="rate" label="Rate" type="number" />
                            </div>

                            <div className="w-[200px]">
                                <InputField control={control} name="quantity" label="Quantity" type="number" />
                            </div>

                            <div className="w-[200px]">
                                <InputField control={control} name="tax" label="Tax %" type="number" />
                            </div>

                            <div className="w-[200px]">
                                <InputField control={control} name="total" label="Total Charges" disabled />
                            </div>

                            <button
                                type="button"
                                onClick={handleAddCharge}
                                className="h-[34px] px-5 rounded border border-blue-900 text-blue-900 text-xs font-semibold hover:bg-blue-50 whitespace-nowrap"
                            >
                                Add
                            </button>
                        </div>

                        {chargeRows.length === 0 ? (
                            <div className="flex flex-col items-center justify-center py-10 text-gray-400 text-sm ">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-10 w-10 mb-2 text-gray-400"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5l5 5v11a2 2 0 01-2 2z"
                                    />
                                </svg>

                                <p>No Records Found...</p>
                            </div>
                        ) : (

                            <div className="mx-3">
                                <TableContainer
                                    component={Paper}
                                    variant="outlined"
                                    sx={{ width: "100%", overflowX: "auto", p: 0, }}
                                >
                                    <Table size="small" stickyHeader sx={{ minWidth: 600 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    sx={{ ...headerCellSx, textAlign: "center", width: 80 }}
                                                >
                                                    Actions
                                                </TableCell>
                                                <TableCell sx={headerCellSx}>Charge</TableCell>
                                                <TableCell sx={headerCellSx}>Rate</TableCell>
                                                <TableCell sx={headerCellSx}>Quantity</TableCell>
                                                <TableCell sx={headerCellSx}>Tax %</TableCell>
                                                <TableCell sx={headerCellSx}>Total</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {chargeRows.map((row, index) => (
                                                <TableRow key={index} sx={{ height: 32 }}>
                                                    <TableCell sx={{ ...bodyCellSx, textAlign: "center" }}>
                                                        <IconButton
                                                            size="small"
                                                            sx={{ padding: "2px" }}
                                                            color="error"
                                                            onClick={() =>
                                                                setChargeRows((prev) =>
                                                                    prev.filter((_, i) => i !== index)
                                                                )
                                                            }
                                                        >
                                                            <DeleteOutline fontSize="small" />
                                                        </IconButton>
                                                    </TableCell>

                                                    <TableCell sx={bodyCellSx}>{row.chargeName?.label}</TableCell>
                                                    <TableCell sx={bodyCellSx}>{row.rate}</TableCell>
                                                    <TableCell sx={bodyCellSx}>{row.quantity}</TableCell>
                                                    <TableCell sx={bodyCellSx}>{row.tax}</TableCell>
                                                    <TableCell sx={bodyCellSx}>{row.total}</TableCell>
                                                </TableRow>
                                            ))}

                                            {chargeRows.length < 3 && (
                                                <TableRow sx={{ height: 200 - chargeRows.length * 32 }}>
                                                    <TableCell colSpan={6} />
                                                </TableRow>
                                            )}
                                        </TableBody>

                                    </Table>
                                </TableContainer>
                            </div>
                        )}
                    </div>
                    <div className="h-[1px] bg-blue-900 w-full mb-1" />

                    {/* ================= Complaint Status ================= */}
                    {complaintStatus && complaintStatus !== "" && (
                        <div className="border rounded-md bg-white my-2">
                            <div className="bg-purple-100 px-3 py-2 rounded-t-md">
                                <span className="text-sm font-semibold text-gray-900">
                                    Complaint Status
                                </span>
                            </div>

                            <div className="p-3 space-y-3">
                                <div className="grid grid-cols-3 gap-3">
                                    <SearchDropdown
                                        control={control}
                                        name="rootCause"
                                        placeholder="Root Cause"
                                    />
                                </div>

                                <div className="grid grid-cols-3 gap-3">
                                    <textarea
                                        className="w-full h-[80px] border rounded px-3 py-2 text-sm resize-none focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        placeholder="CA"
                                    />

                                    <textarea
                                        className="w-full h-[80px] border rounded px-3 py-2 text-sm resize-none focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        placeholder="PA"
                                    />

                                    <textarea
                                        className="w-full h-[80px] border rounded px-3 py-2 text-sm resize-none focus:outline-none focus:ring-1 focus:ring-blue-500"
                                        placeholder="Remark"
                                    />
                                </div>

                                <div className="grid grid-cols-3 gap-3">
                                    <SearchDropdown
                                        control={control}
                                        name="complaintStatus"
                                        placeholder="Complaint Status"
                                    />

                                    <SearchDropdown
                                        control={control}
                                        name="completedResolved"
                                        placeholder="Completed/Resolved"
                                        searchIcon
                                    />

                                    <div className="flex items-center gap-2">
                                        <label className="h-[36px] px-3 rounded border  border-blue-900  bg-blue-900 text-white text-sm font-semibold flex items-center cursor-pointer">
                                            Choose files
                                            <input type="file" className="hidden" />
                                        </label>
                                        <span className="text-sm text-gray-500">No file chosen</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    )}
                    {/* <div className="h-[1px] bg-blue-900 w-full mb-1" /> */}

                    {/* ================= Uplodas Documents/ Bills ================= */}
                    <div className="border rounded-md bg-white mt-2">

                        <div className="px-3 py-2 font-semibold text-sm">
                            Upload Documents/Bills/Invoices
                        </div>


                        <div className="px-3 py-3 flex items-center justify-between gap-4">

                            <div className="flex items-center gap-3 w-full">
                                <div className="w-[240px]">
                                    <SearchDropdown
                                        control={control}
                                        name="documentType"
                                        placeholder="Document Type"
                                        dataArray={documentTypeOptions}
                                        inputValue={documentTypeSearch}
                                        isClearable
                                        handleInputChange={handleDocumentTypeSearch}
                                        getOptionLabel={(option) => option?.documentTypeName || option?.value || ""}
                                        isOptionEqualToValue={(option, value) =>
                                            option?.id === value?.id
                                        }
                                        size="small"
                                    />

                                </div>


                                <div className="flex items-center gap-2">
                                    <label className="h-[36px] px-3 rounded bg-blue-900 text-white text-sm font-semibold flex items-center cursor-pointer">
                                        Choose files
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            className="hidden"
                                            multiple
                                            onChange={handleFileChange}
                                        />
                                    </label>


                                    <div
                                        className="flex items-center gap-2 overflow-x-auto whitespace-nowrap max-w-[800px]"
                                        style={{
                                            scrollbarWidth: "thin",
                                            scrollbarColor: "#9ca3af #e5e7eb",

                                        }}
                                    >

                                        {files.map((file, index) => (
                                            <div
                                                key={`file-${index}`}
                                                className="flex items-center gap-2 px-3 py-1 border rounded text-sm bg-blue-50"
                                            >
                                                <span className="max-w-[180px] truncate">
                                                    {file.name}
                                                </span>

                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setFiles(prev => prev.filter((_, i) => i !== index));
                                                        if (fileInputRef.current) {
                                                            fileInputRef.current.value = null;
                                                        }
                                                    }}
                                                    className="text-red-500 font-bold"
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))}


                                        {documents.map((doc, index) => (
                                            <div
                                                key={`doc-${index}`}
                                                className="flex items-center gap-2 px-3 py-1 border rounded text-sm bg-gray-50"
                                            >
                                                <span className="max-w-[180px] truncate">
                                                    {doc.fileName}
                                                </span>

                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setDocuments(prev => prev.filter((_, i) => i !== index));
                                                    }}
                                                    className="text-red-500 font-bold"
                                                >
                                                    ✕
                                                </button>
                                            </div>
                                        ))}

                                    </div>

                                </div>

                            </div>

                            <div className="flex items-center gap-2">
                                <button
                                    type="button"
                                    onClick={resetAllData}
                                    className="h-[36px] px-4 rounded border border-red-500 text-red-500 text-sm font-semibold hover:bg-red-50"
                                >
                                    Reset
                                </button>

                                <button
                                    type="button"
                                    disabled={!isDocumentValid}
                                    onClick={async () => {

                                        if (files.length > 0) {
                                            await handleAddDocument();
                                        }

                                        setConfirmOpen(true);
                                    }}
                                    className={`h-[36px] px-4 rounded text-white text-sm font-semibold
                                      ${!isDocumentValid
                                            ? "bg-gray-400 cursor-not-allowed"
                                            : "bg-blue-900 hover:bg-blue-800"}
                                         `}
                                >
                                    Save
                                </button>

                            </div>

                        </div>
                    </div>

                </div>

                <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                    <DialogTitle>Confirm Save</DialogTitle>

                    <DialogContent>
                        Are you sure you want to save maintenance details?
                    </DialogContent>

                    <DialogActions>
                        <Button
                            color="success"
                            onClick={() => setConfirmOpen(false)}>
                            Cancel
                        </Button>

                        <Button variant="contained"
                            color="success"
                            onClick={handleSave}>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>

            </Box >
        </Modal >

    );
}